// src/components/Calendar/CalendarVoteDialog.jsx
import React from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import CalendarVoteBox from './CalendarVoteBox';

/**
 * “투표” 아이콘 클릭 시 뜨는 모달
 *
 * props
 *  ─ open      : Boolean – 모달 열림/닫힘
 *  ─ onClose   : Function – 닫기 콜백
 *  ─ schedule  : { id, title, type, vote: { … } }
 */
export default function CalendarVoteDialog({ open, onClose, schedule }) {
    // vote 정보가 없으면 아무것도 렌더하지 않음
    if (!schedule?.vote) return null;

    /** 투표 완료 → 최신 schedule 객체를 전파 후 모달 닫기 */
    const handleVoteSuccess = (updatedSchedule) => {
        // 전역에 알림 (CalendarView에서 listener로 events 업데이트)
        window.dispatchEvent(
            new CustomEvent('schedule-updated', { detail: updatedSchedule })
        );
        onClose();        // 모달 닫기
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ fontWeight: 700 }}>
                🗳️ {schedule.title || schedule.type} 투표
            </DialogTitle>

            <DialogContent dividers>
                <CalendarVoteBox
                    postId={schedule.id}
                    voteData={schedule.vote}
                    hasVoted={schedule.vote.has_voted}
                    onVoteSuccess={handleVoteSuccess}
                    isAnonymousVote={schedule.vote.is_anonymous}
                    allowMultiple={schedule.vote.allow_multiple}
                />
            </DialogContent>
        </Dialog>
    );
}